/**
 * API CEI Apps
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `Celular` - Celular * `Residencial` - Residencial * `Comercial` - Comercial * `Recado` - Recado
 */
export enum Tipo39aEnum {

    CELULAR = 'Celular',

    RESIDENCIAL = 'Residencial',

    COMERCIAL = 'Comercial',

    RECADO = 'Recado'
}

